import { useState, useEffect } from 'react'
import algoliasearch from 'algoliasearch'
import { getClosestAlgoliaItemsByIp } from '@lib/algolia'
import { geocode } from '@lib/geo-api'

const client = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_API_KEY)
const algoliaIndex = client.initIndex(process.env.ALGOLIA_GROUP_EVENTS_INDEX_NAME)

const attributesToRetrieve = [
  'title',
  'coach_facility_name',
  'slug',
  'start_date_time',
  'end_date_time',
  'featured_image_url',
  'price_in_cents',
  'coach_facility_city',
  'coach_facility_state',
  'coach_facility_zip',
  'coach_facility_street',
  'coach_facility_timezone',
  'max_attendance',
  'registration_count',
  'registration_full',
  'tags',
  'url',
  'lesson_count',
  'additional_fees',
  'has_waitlist',
]

export const useNearestGroupEventsByIp = (eventsToShow, searchRadius = 100 * 1609, filters = '') => {
  const [nearestGroupEvents, setNearestGroupEvents] = useState([])

  useEffect(() => {
    const getNearestGroupEvents = async () => {
      const { hits: events } = await getClosestAlgoliaItemsByIp(
        algoliaIndex,
        eventsToShow,
        searchRadius,
        filters,
        attributesToRetrieve,
      )
      if (events) {
        setNearestGroupEvents(events)
      }
    }
    getNearestGroupEvents()
  }, [eventsToShow])

  return nearestGroupEvents
}

const twentyFiveMilesInMeters = 25 * 1609

export const useNearestGroupEventsFromAddress = ({
  address,
  aroundRadius = twentyFiveMilesInMeters,
  hitsPerPage = 6,
} = {}) => {
  const {
    street,
    city,
    state,
    zip,
  } = address

  const [nearestGroupEvents, setNearestGroupEvents] = useState([])

  useEffect(() => {
    const getNearestGroupEvents = async () => {
      const geocodeResult = await geocode({
        street,
        city,
        state,
        zip,
      })
      if (geocodeResult != null) {
        const currentTime = new Date().getTime() / 1000
        const filters = `start_date_time_ts > ${currentTime}`
        const { hits } = await algoliaIndex.search('', {
          aroundLatLng: `${geocodeResult.lat}, ${geocodeResult.lng}`,
          attributesToRetrieve,
          filters,
          hitsPerPage,
          aroundRadius,
          getRankingInfo: true,
        })

        if (hits) {
          setNearestGroupEvents(hits)
        }
      }
    }

    getNearestGroupEvents()
  }, [])

  return nearestGroupEvents
}
